import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FIX_ORDER_BASE_PATH } from '../../../../../../../../../features/fix/order/fix-order-routing';

// This route exists just to provide breadcrumbs for the FIX order subpages.
export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-order/_fix-order')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'fix-order-list',
        label: 'OMS',
        to: FIX_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
